import axios from 'axios'
import accounts from './accounts'
import cards from './cards'
import payments from './payments'
import organizations from './organizations'
import patients from './patients'
import store from 'reducers'
import _ from 'lodash'
import { uuid } from 'lib/helpers';
import { TrackingActions } from 'actions'

class ApiClient {
    constructor(){
        let baseURL = ''

        let hashes = location.search.slice(location.search.indexOf('?') + 1).split('&');
        let params = {};
        
        hashes.map(hash => {
            let [key, val] = hash.split('=');
            params[key] = decodeURIComponent(val);
        })

        if (params.version){
            baseURL = `https://${params.version.replace('.', '')}.appspot.com`
        } else if(params.subdomain){
            baseURL = `https://${params.version.replace('.', '')}.nextinline.io`
        } else if(window.location.host.includes('localhost')){
			baseURL = 'http://localhost:4000'
		} else if(window.location.origin.includes('nextinline.io')){
			baseURL= window.location.origin.replace('minnow', 'shark').replace('otter', 'shark').replace('scheduling', 'shark').replace('www', 'shark')
		}else{
            baseURL= 'https://shark.nextinline.io'
        }

        baseURL = baseURL + '/widget/'

        this.options = {
            baseURL
        }
    }
    get sessionID(){
        let sessionID;
        sessionID = sessionStorage.getItem('sessionID')
        if(!sessionID){
            sessionID = uuid()
            sessionStorage.setItem('sessionID', sessionID)
        }
        return sessionID;
    }
    get client(){
        const {baseURL} = this.options
        let headers = {};
        const token = (store.getState().session || {}).accessToken
        const config = store.getState().config || {}

        var cancelToken = axios.CancelToken.source();
        this.token = cancelToken


        if(token) headers['x-token'] = token
        if(config.demoMode) headers['x-demo-mode'] = config.demoMode
        if(config.organizationID) headers['x-organization-id'] = config.organizationID
        
        headers['x-minnow-session-id'] = this.sessionID

        return axios.create({
            baseURL,
            headers,
            cancelToken: cancelToken.token
        })
    }
    get accounts(){
        return new accounts({client: this.client})
    }
    /**
     * @returns {organizations}
     */
    get organizations(){
        return new organizations({client: this.client})
    }
    get patients(){
        return new patients({client: this.client})
    }
    get cards(){
        return new cards({client: this.client})
    }
    get payments(){
        return new payments({client: this.client})
    }
}
const nilApiClient = new ApiClient()
window.nilApiClient = nilApiClient


export default nilApiClient


// WEBPACK FOOTER //
// ./lib/apiClient/index.js